import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Subject } from 'rxjs';

import { ConfigService } from './config.service';
import { ReportData } from '../models/report-data.model';
import { ReportFilters } from '../models/report-filters.model';
import { ReportExportData } from '../models/report-export.model';
import { timeout } from 'rxjs/operators';

@Injectable()
export class ReportService {
    readonly apiServer: string;
    ExportData:ReportExportData;

    private reportSummarySelected = new Subject<string>();
    public summarySelection$ = this.reportSummarySelected.asObservable();

    constructor(private _configService: ConfigService, private _http: HttpClient) {
        this.apiServer = this._configService.appSettings.webApiServer + "api/Reports/";        
    }

    announceSummarySelected(summarySelected: string) {
        this.reportSummarySelected.next(summarySelected);
    }

    async getAcuityTrendsReport(filters:ReportFilters): Promise<ReportData> {
        const params = new HttpParams()
            .set('request', JSON.stringify(filters));

        return await this._http.get<ReportData>(`${this.apiServer}Acuity/GetAcuityTrendsReport`, { params: params }).toPromise<ReportData>();
    }

    async getTotalUosTrendsReport(filters:ReportFilters): Promise<ReportData> {
        const params = new HttpParams()
            .set('request', JSON.stringify(filters));

        return await this._http.get<ReportData>(`${this.apiServer}TotalUosReport/GetTotalUosTrendsReport`, { params: params }).toPromise<ReportData>();
    }

    async getDailyChurnReport(filters:ReportFilters): Promise<ReportData> {
        const params = new HttpParams()
            .set('request', JSON.stringify(filters));

        return await this._http.get<ReportData>(`${this.apiServer}DailyChurn/GetDailyChurnReport`, { params: params }).toPromise<ReportData>();
    }

    async GetPerformanceReport(filters:ReportFilters): Promise<ReportData> {
        const params = new HttpParams()
        .set('request', JSON.stringify(filters));

        return await this._http.get<ReportData>(`${this.apiServer}Performance/GetPerformanceReport`, { params: params }).toPromise<ReportData>();
    }

    async getMeasureReport(filters:ReportFilters): Promise<ReportData> {
        const params = new HttpParams()
        .set('request', JSON.stringify(filters));

        return await this._http.get<ReportData>(`${this.apiServer}Measure/getMeasureReport`, { params: params }).toPromise<ReportData>();
    }

    async getReasonsForVarianceReport(filters:ReportFilters): Promise<ReportData> {
        const params = new HttpParams()
        .set('request', JSON.stringify(filters));

        return await this._http.get<ReportData>(`${this.apiServer}ReasonsForVariance/getReasonsForVarianceReport`, { params: params }).toPromise<ReportData>();
    }


    async getExportData(filters:ReportFilters,exportUrl:string):Promise<ReportExportData>{
       const params = new HttpParams()
      .set('request', JSON.stringify(filters));
      return await this._http.get<ReportExportData>(`${this.apiServer}${exportUrl}`,{params:params}).toPromise<ReportExportData>();
    }

    async getExecutiveVarianceReport(filters:ReportFilters) : Promise<ReportData> {
        const params = new HttpParams()
        .set('request', JSON.stringify(filters));

        return await this._http.get<ReportData>(`${this.apiServer}ExecutiveVariance/GetExecutiveVarianceReport`, { params: params }).toPromise<ReportData>();
    }
}
